import { z } from 'zod';
import { PositiveDecimalString } from './common.js';

/** POST /api/level-upgrade/rp-to-ap — RP→AP 1:1 then hang-buy queue (prod RP转AP). */
export const RpToApHangSchema = z.object({
  amount: PositiveDecimalString,
  transaction_password: z.string().min(1).max(128),
  security_answer: z.string().min(1).max(256),
  memo: z.string().max(500).optional(),
  idempotency_key: z.string().max(64).optional(),
});

export type RpToApHangRequest = z.infer<typeof RpToApHangSchema>;
